import { useEffect, useState } from 'react';
import axios from 'axios';
import { base_url } from '../baseUrl';

const useSalesOrdersByCustomerId = (customerId) => {
  const [salesOrders, setSalesOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!customerId) {
      setLoading(false);
      return;
    }

    const fetchSalesOrders = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(
          `${base_url}api/salesorders/customer/${customerId}`
        );

        if (response.data?.salesOrders) {
          setSalesOrders(response.data.salesOrders);
        } else {
          setSalesOrders([]);
          setError(response.data?.message || 'No sales orders found.');
        }
      } catch (err) {
        setError(err.message || 'Error fetching sales orders');
        setSalesOrders([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSalesOrders();
  }, [customerId]);

  return {
    salesOrders,
    loading,
    error,
  };
};

export default useSalesOrdersByCustomerId;
